export default __webpack_public_path__ + "static/media/img_upee_a-min.6b463c37.jpg";